import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import "react-tabs/style/react-tabs.css";
import TablaFechasVencimientoDecAnti from "./tablaFechasVencimientoDecAnti";
import TablaFechasVencimientoDecDefi from "./tablaFechasVencimientoDecDefi";
import TablaFechasVencimientoRete from "./tablaFechasVencimientoRete";
import { DangerButton } from "../../../ui/buttons/Button";

export const TablaFechasVencimiento = (props) => {
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo] = useState();
  const [msg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2] = useState();
  const [msg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const handleCloseSi = () => {
    setMostrar1(false);
  };
  const handleCloseNo = () => {
    setMostrar1(false);
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const salir = () => {
    props.setShow(false);
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setTabIndex(0);
        setContar1(0);
      }}
    >
      <Modal.Header className="azulGradiant">
        Fechas de Vencimiento
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav " id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link bg-blue-100 text-light rounded"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Primera Quincena
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link bg-blue-200 text-light rounded"
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Segunda Quincena
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link bg-blue-300 text-light rounded"
                id="hist-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Retenciones
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <TablaFechasVencimientoDecAnti />
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaFechasVencimientoDecDefi />
            </div>

            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <TablaFechasVencimientoRete />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
